var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail',{attrs:{"object-name":"CDS_T_Disaster__c","layout-name":"DisasterLayout","default-title":"新規災害作成","saved-page":"CDS_VF_DisasterDetail","detail-page-name":"CDS_VF_DisasterDetail","list-page":"CDS_VF_DisasterList","list-view-props":{
    canSearch: false,
  },"every-overwrite-value":_vm.everyOverwriteValue,"override":_vm.override},scopedSlots:_vm._u([{key:"layout",fn:function(slotProps){return [_c('DetailLayout',{attrs:{"slot-props":slotProps}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }